import { render, staticRenderFns } from "./Set.vue?vue&type=template&id=7b3670b3"
import script from "./Set.vue?vue&type=script&lang=js"
export * from "./Set.vue?vue&type=script&lang=js"
import style0 from "./Set.vue?vue&type=style&index=0&id=7b3670b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports